/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./pc-header.vue?vue&type=template&id=47fe5914&scoped=true"
import script from "./pc-header.vue?vue&type=script&lang=js"
export * from "./pc-header.vue?vue&type=script&lang=js"
import style0 from "./pc-header.vue?vue&type=style&index=0&id=47fe5914&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fe5914",
  null
  
)

export default component.exports
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import qInstall from "../../../node_modules/@quasar/app/lib/webpack/runtime.auto-import.js";
qInstall(component, 'components', {QToggle,QBtn,QMenu,QBadge});
